import React from 'react';
import { Link } from 'react-router-dom';
import rjp from "../../assests/rjp.jpg";
import dt from "../../assests/dt.jpg";
import fp from "../../assests/fp.jpg";
import gn from "../../assests/gn.jpg";
import ra from "../../assests/ra.jpg";
import drm from "../../assests/drm.jpg";
import dmt from "../../assests/dmt.jpg";
import sg from "../../assests/sg.jpg";
import dsc from "../../assests/dsc.jpg";
import dws from "../../assests/dws.jpg";
import dv from "../../assests/dv.jpg";
import jc from "../../assests/jc.jpg";
import dbk from "../../assests/dbk.jpg";
import jp from "../../assests/jp.jpg";
import pp from "../../assests/pp.jpg";
import jb from "../../assests/jbf.jpg";
import tc from "../../assests/tc.jpg";
import de from "../../assests/de.jpg";
import drh from "../../assests/drh.jpg";
import ah from "../../assests/ah.jpg";
import jpr from "../../assests/jrr.jpg";
import sv from "../../assests/sv.jpg";
import dh from "../../assests/dh.jpg";
import tp from "../../assests/tp.jpg";
import dlg from "../../assests/dlg.jpg";

function OurTeam() {
  const staff = [
    { img: rjp, name: "Rev. Jameson P. Titus", title: "President" },
    { img: dt, name: "Deanna Titus", title: "Secretary" },
    { img: fp, name: "Florence Porter", title: "Personal Assistant to Jameson P. Titus" },
    { img: gn, name: "George Newman", title: "Development Officer" },
  ];

  const board = [
    { img: rjp, name: "Rev. Jameson P. Titus", title: "President" },
    { img: ra, name: "Robert Allsup", title: "Vice President" },
    { img: dt, name: "Deanna Titus", title: "Board Secretary" },
    { img: drm, name: "Dr. Rick Mortimer", title: "Director" },
    { img: dmt, name: "Dr. Mathew Thomas", title: "Director" },
    { img: sg, name: "Sarada Galloway", title: "Director" },
    { img: dsc, name: "Dr. Sonny Conatser", title: "Director" },
    { img: dws, name: "Dr. William Salisbury", title: "Director" },
    { img: dv, name: "Daniel Vecore", title: "Director" },
  ];

  const ambassadors = [
    { img: jc, name: "Joseph Cole", title: "Former Board Member" },
    { img: dbk, name: "Dr. Barry Kolb", title: "Former Vice President" },
    { img: jp, name: "Jerry Price", title: "Former Board Member" },
    { img: pp, name: "Paul Price", title: "Former Board Member" },
    { img: jb, name: "Janene Brunk", title: "Former Board Member" },
    { img: tc, name: "Tim Cummings", title: "Former Board Member" },
    { img: de, name: "Douglas Erickson", title: "Former Board Member" },
    { img: drh, name: "Dr. Ron Hammonds", title: "Former Board Member" },
    { img: ah, name: "Ashley Hammonds", title: "Former Board Member" },
    { img: jpr, name: "Jon Paul Robles", title: "Former Board Member" },
    { img: sv, name: "Stirling Vineyard", title: "Former Board Member" },
    { img: dh, name: "Donny Hatcher", title: "Former Board Member" },
    { img: tp, name: "Teena Phillips", title: "Former Board Member" },
    { img: dlg, name: "Dr. Landon Galloway", title: "Former Board Member" },
  ];

  const PeopleGrid = ({ people }) => (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "1.5rem", marginBottom: "2.5rem" }}>
      {people.map((p, i) => (
        <div key={i} style={{ width: "120px", display: "flex", flexDirection: "column", alignItems: "center" }}>
          <img
            src={p.img}
            alt={p.name || "Team member"}
            style={{ width: "120px", height: "120px", objectFit: "cover", borderRadius: "4px" }}
          />
          {p.name && (
            <p style={{ fontSize: "12px", color: "#222", textAlign: "center", marginTop: "0.5rem", marginBottom: "2px", fontWeight: 600 }}>
              {p.name}
            </p>
          )}
          {p.title && (
            <p style={{ fontSize: "11px", color: "#777", textAlign: "center", margin: 0, lineHeight: "1.3" }}>
              {p.title}
            </p>
          )}
        </div>
      ))}
    </div>
  );

  return (
    <div style={{ fontFamily: "'Georgia','Times New Roman',serif", color: "#222", backgroundColor: "#fff" }}>
      <div style={{ maxWidth: "900px", margin: "0 auto", padding: "0 1.5rem 3.5rem" }}>
        {/* ── Back link ── */}
        <Link to="/" style={{ fontSize: "13px", color: "#c47a1e", margin: "1.5rem 0 0", display: "inline-block", textDecoration: "none", userSelect: "none" }}>
          ← Back to Home
        </Link>

        {/* ── "Our Team" heading ── */}
        <h1 style={{ fontFamily: "'Dancing Script','Brush Script MT',cursive", fontSize: "2.4rem", color: "#c47a1e", margin: "1.2rem 0 0.15rem", fontWeight: 700 }}>
          Our Team
        </h1>
        <div style={{ display: "flex", gap: "4px", marginBottom: "2rem" }}>
          {[...Array(9)].map((_, i) => (
            <div key={i} style={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: "#c47a1e" }} />
          ))}
        </div>

        {/* ── Our Staff ── */}
        <h3 style={{ fontSize: "1.05rem", fontWeight: 700, color: "#222", marginBottom: "1.2rem" }}>
          Our Staff
        </h3>
        <PeopleGrid people={staff} />

        {/* ── Our Board ── */}
        <h3 style={{ fontSize: "1.05rem", fontWeight: 700, color: "#222", marginBottom: "1.2rem" }}>
          Our Board
        </h3>
        <PeopleGrid people={board} />

        {/* ── Our Ambassadors ── */}
        <h3 style={{ fontSize: "1.05rem", fontWeight: 700, color: "#222", marginBottom: "1.2rem" }}>
          Our Ambassadors
        </h3>
        <PeopleGrid people={ambassadors} />
      </div>
    </div>
  );
}

export default OurTeam;
